import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

const GridImage = ({ image, directory, open }) => {

    const viewImage = () => {
        open(image);
    };

    return (
        <button className={`main-${directory}__button`} onClick={viewImage}>
            <GatsbyImage image={image} className={`main-${directory}__image`} alt=""/>
        </button>
    );
};

export default GridImage;
